import { getObjectUtil } from 'packages/src'
import { WORKOUT_EXERCISE_KEY } from '../../../../workout-exercise/model'
import { EXERCISE_KEY } from '../../../../exercise'
import getDomainMapExercisesSelect from '../../../../exercise/redux/selectors/get-domain-map'
import createPointerReduxUtil from '../../../../redux/utils/create-pointer'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import updateReduxUtil from '../../../../redux/utils/update'
import { WORKOUT_EXERCISES_PATH } from '../../../../workout-exercise/redux/constants'
import getWorkoutExercisesWorkoutSectionUtil from '../../../model/utils/get-workout-exercises'
import getCurrentWorkoutSectionSelect from '../get-current'
import { createSelector } from 'reselect'

const getCurrentWorkoutExercisesWorkoutSectionSelect = createSelector(
  getCurrentWorkoutSectionSelect,
  state => getObjectUtil(state, WORKOUT_EXERCISES_PATH.DATA),
  getDomainMapExercisesSelect,
  (workoutSection, workoutExercisesDomainMap, exercisesDomainMap) => {
    if (!workoutSection) {
      return []
    }
    return getWorkoutExercisesWorkoutSectionUtil(workoutSection)
      .reduce((arr, workoutExercisePointer) => {
        const workoutExercise = workoutExercisesDomainMap[getIdReduxUtil(
          workoutExercisePointer)]
        if (!workoutExercise) {
          return arr
        }
        const exercise = exercisesDomainMap[getValueReduxUtil(
          workoutExercise,
          WORKOUT_EXERCISE_KEY.EXERCISE_ID
        )]
        const updates = updateReduxUtil(workoutExercise, {
          [WORKOUT_EXERCISE_KEY.EXERCISE]: createPointerReduxUtil(exercise,
            [EXERCISE_KEY.NAME]
          )
        })
        arr.push(updates)
        return arr
      }, [])
  }
)

export default getCurrentWorkoutExercisesWorkoutSectionSelect
